module.exports = __webpack_public_path__ + "img/f5-01.356b0b11.png";